"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LockfileType = exports.Scope = void 0;
exports.parseManifestFile = parseManifestFile;
exports.getTopLevelDeps = getTopLevelDeps;
exports.createDepTreeDepFromDep = createDepTreeDepFromDep;
exports.getYarnWorkspaces = getYarnWorkspaces;
exports.getPnpmWorkspaces = getPnpmWorkspaces;
const errors_1 = require("../errors");
const utils_1 = require("../utils");
var Scope;
(function (Scope) {
    Scope["prod"] = "prod";
    Scope["dev"] = "dev";
})(Scope || (exports.Scope = Scope = {}));
var LockfileType;
(function (LockfileType) {
    LockfileType["npm"] = "npm";
    LockfileType["npm7"] = "npm7";
    LockfileType["yarn"] = "yarn";
    LockfileType["yarn2"] = "yarn2";
    LockfileType["pnpm"] = "pnpm";
})(LockfileType || (exports.LockfileType = LockfileType = {}));
function parseManifestFile(manifestFileContents) {
    return (0, utils_1.parseJsonFile)(manifestFileContents, 'package.json');
}
function getTopLevelDeps({ targetFile, includeDev, includePeerDeps = false, applyYarn2Resolutions = false, }) {
    let dependencies = [];
    const dependenciesIterator = Object.entries({
        ...targetFile.dependencies,
        ...(includeDev ? targetFile.devDependencies : null),
        ...(targetFile.optionalDependencies || {}),
    });
    for (const [name, version] of dependenciesIterator) {
        dependencies.push({
            dev: includeDev && targetFile.devDependencies
                ? !!targetFile.devDependencies[name]
                : false,
            name,
            version,
        });
    }
    if (includePeerDeps && targetFile.peerDependencies) {
        for (const [name, version] of Object.entries(targetFile.peerDependencies)) {
            if (targetFile?.peerDependenciesMeta?.[name]?.optional) {
                continue;
            }
            dependencies.push({
                name,
                version,
            });
        }
    }
    if (applyYarn2Resolutions && targetFile.resolutions) {
        const resMap = new Map(Object.entries(targetFile.resolutions).map(([resName, resVersion]) => {
            let key = resName.replace(`${targetFile.name}/`, '');
            // Patch resolution keys use the format "name@npm:range" (e.g. "papaparse@npm:^5.3.0").
            // Extract the bare package name so it can be matched against dep.name.
            // The [^/] guard avoids matching scoped resolutions that target a sub-dependency
            // (e.g. "debug@npm:4.3.2/ms"), which are handled separately in findResolutions.
            const npmPrefixMatch = key.match(/^(.+)@npm:[^/]+$/);
            if (npmPrefixMatch) {
                key = npmPrefixMatch[1];
            }
            return [key, resVersion];
        }));
        dependencies = dependencies.map((dep) => resMap.has(dep.name) ? { ...dep, version: resMap.get(dep.name) } : dep);
    }
    return dependencies;
}
function createDepTreeDepFromDep(dep, showNpmScope) {
    return {
        labels: {
            scope: dep.dev ? Scope.dev : Scope.prod,
            ...(showNpmScope && { 'npm:scope': dep.dev ? Scope.dev : Scope.prod }),
        },
        name: dep.name,
        version: dep.version,
    };
}
function getYarnWorkspaces(targetFile) {
    try {
        const packageJson = parseManifestFile(targetFile);
        if (!!packageJson.workspaces && !!packageJson.private) {
            if (Array.isArray(packageJson.workspaces)) {
                return packageJson.workspaces;
            }
            if ('packages' in packageJson.workspaces &&
                Array.isArray(packageJson.workspaces.packages)) {
                return packageJson.workspaces.packages;
            }
        }
        return false;
    }
    catch (e) {
        throw new errors_1.InvalidUserInputError('package.json parsing failed with ' + `error ${e.message}`);
    }
}
function getPnpmWorkspaces(workspacesYamlFile) {
    try {
        // js-yaml 4 returned a nullish value for empty (or comment-only)
        // documents where js-yaml 5 throws; loadYamlOrNull preserves the old
        // behavior of falling through to the default below.
        const rawPnpmWorkspacesYaml = (0, utils_1.loadYamlOrNull)(workspacesYamlFile);
        if (rawPnpmWorkspacesYaml && rawPnpmWorkspacesYaml.packages) {
            if (Array.isArray(rawPnpmWorkspacesYaml.packages)) {
                return rawPnpmWorkspacesYaml.packages;
            }
        }
        // By default, all packages of all subdirectories are included.
        // https://pnpm.io/pnpm-workspace_yaml
        return ['*'];
    }
    catch (e) {
        throw new errors_1.InvalidUserInputError(`pnpm-workspace.yaml parsing failed with error ${e.message}`);
    }
}
//# sourceMappingURL=index.js.map